// Espelho da lógica de promoções do backend (apply_promotion) para mostrar preços no POS
// parentOf: { subcategoria_id: categoria_principal_id } — promoções na principal abrangem subcategorias
export const promotionFor = (product, promos = [], parentOf = {}) => {
  const base = Number(product.price || 0);
  let bestPrice = base;
  let best = null;
  const catIds = [product.category_id, parentOf[product.category_id]].filter(Boolean);
  for (const p of promos) {
    const pids = p.product_ids || [];
    const cids = p.category_ids || [];
    if ((pids.length || cids.length) && !pids.includes(product.product_id) && !catIds.some((c) => cids.includes(c))) continue;
    const value = Number(p.discount_value || 0);
    let price = p.discount_type === "percent" ? base * (1 - value / 100) : base - value;
    price = Math.max(0, Math.round(price * 100) / 100);
    if (price < bestPrice) {
      bestPrice = price;
      best = p;
    }
  }
  return { price: bestPrice, promo: best, original: base };
};

export const promoLabel = (p) => (p.discount_type === "percent" ? `-${Number(p.discount_value)}%` : "PROMO");
